import React, { createContext, useContext } from "react";
import { brand as fallbackBrand } from "./config";

const BrandContext = createContext(fallbackBrand);

export function BrandProvider({ brand, children }) {
  return (
    <BrandContext.Provider value={brand || fallbackBrand}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}

/** Color tokens shaped like legacy `BRAND` export. */
export function useBrandColors() {
  const b = useBrand();
  return b.colors;
}
